import React from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {BreadcrumbItemStructure} from 'app/general/structures/BreadcrumbItemStructure';
import {SPPage} from 'app/general/structures/SPPage';
import {getUserDetailPageURL} from 'app/urls';
import {CreateUserForm} from 'app/user/components/CreateUserForm/CreateUserForm';
import {gt} from 'app/utils/i18n';

import {UserSerializedType} from 'sweet-types';

import type {BreadcrumbProps} from 'app/general/structures/BreadcrumbItemStructure';

type Props = WithRouterProps;

export const UserCreatePage = withRouter<Props>((props: Props) => {
  const handleCreateUser = (user: UserSerializedType) =>
    Promise.resolve(props.router.push(getUserDetailPageURL(user.id)));

  return (
    <SPPage title={gt('Add new member')}>
      {() => (
        <CreateUserForm
          isPopover={false}
          className="page-form"
          showTeams={true}
          onCreateUser={handleCreateUser}
          showCancelButton={false}
        />
      )}
    </SPPage>
  );
});

export const UserCreateBreadcrumb = (props: BreadcrumbProps): JSX.Element => (
  <BreadcrumbItemStructure {...props} text={gt('Add new member')} />
);
